import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  ClockCircleOutlined
} from '@ant-design/icons'
import { Tag } from 'antd'

export const statusTag = (status: string) => {
  switch (status) {
    case 'success': {
      return (
        <Tag color='green' icon={<CheckCircleOutlined />}>
          Success
        </Tag>
      )
    }
    case 'error': {
      return (
        <Tag color='red' icon={<ExclamationCircleOutlined />}>
          Error
        </Tag>
      )
    }
    case 'running': {
      return (
        <Tag color='blue' icon={<ClockCircleOutlined />}>
          Running
        </Tag>
      )
    }
    default: {
      return <Tag>{status}</Tag>
    }
  }
}
